export class SchemaItem {
  constructor() {
    if (this.constructor === SchemaItem) {
      throw new Error(
        'Schema item is an abstract class and cannot be instantiated'
      );
    }
  }
}
